import Card from 'scripts/models/api/cards/base/card';
import Image from 'scripts/models/api/image/image';

export default Card.extend({
    define: {
        title: {
            type: 'string',
            value: ''
        },
        image: Image,
        shareUrl: {
            type: 'string',
            value: ''
        }
    }
});